import { render, staticRenderFns } from "./modalEditarProductoNew.vue?vue&type=template&id=33b5c773&scoped=true"
import script from "./modalEditarProductoNew.vue?vue&type=script&lang=js"
export * from "./modalEditarProductoNew.vue?vue&type=script&lang=js"
import style0 from "./modalEditarProductoNew.vue?vue&type=style&index=0&id=33b5c773&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b5c773",
  null
  
)

export default component.exports